/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Title_PlaceholderInputs */

const en_settings_tickets_title_placeholder = /** @type {(inputs: Settings_Tickets_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief summary of your issue`)
};

/**
* | output |
* | --- |
* | "Brief summary of your issue" |
*
* @param {Settings_Tickets_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_title_placeholder = /** @type {((inputs?: Settings_Tickets_Title_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Title_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_title_placeholder(inputs)
});
export { settings_tickets_title_placeholder as "settings.tickets.title_placeholder" }